import { inject, Injectable, signal } from '@angular/core';
import { Booking } from '../../core/models';

@Injectable({
  providedIn: 'root',
})
export class BookingDataService {
  private _booking = signal<Booking | null>(null);

  get booking() {
    return this._booking.asReadonly(); // Provide a readonly version to prevent accidental modification
  }

  // Method to set the booking state
  setBooking(booking: Booking) {
    if (!booking.id) {
      //      booking.id = uuidv4();
    }

    this._booking.set(booking);
  }

  // Method to clear the booking state
  clearBooking() {
    this._booking.set(null);
  }
}
